// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1LxPb","paramInput":"JobSimulator_paramInput__238zy","input":"JobSimulator_input__25MXs"};